module.exports = __webpack_public_path__ + "img/website_header_final.1a82d0dd.png";